import usePageViews from "hooks/usePageViews";
import { Language } from "interfaces/locale";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import { ROUTES } from "helpers/routes";
import AuthenticationPage from "./AuthenticationPage";
import EnforcerPage from "./EnforcerPage";
import EntitiesPage from "./EntitiesPage";
import LandingPage from "./LandingPage";
import StreetPage from "./StreetPage";
import RedirectRoutes from "./RedirectRoutes";

const PublicRoutes = ({ locale }: { locale: Language }) => {
  usePageViews();

  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== locale) i18n.changeLanguage(locale);
  }, [locale, i18n]);

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path={ROUTES[locale].enforcer} element={<EnforcerPage />} />
      <Route path={ROUTES[locale].street} element={<StreetPage />} />
      <Route
        path={ROUTES[locale].login}
        element={<AuthenticationPage screen="login" />}
      />
      <Route
        path={ROUTES[locale].passwordRecovery}
        element={<AuthenticationPage screen="password-recovery" />}
      />
      <Route
        path={ROUTES[locale].twoFactorAuthentication}
        element={<AuthenticationPage screen="two-factor-authentication" />}
      />
      <Route
        path={ROUTES[locale].passwordDefinition}
        element={<AuthenticationPage screen="password-definition" />}
      />
      <Route path={ROUTES[locale].entities} element={<EntitiesPage />} />
      <Route path="*" element={<RedirectRoutes />} />
    </Routes>
  );
};

export default PublicRoutes;
